import React from "react";
import ReactDOM from "react-dom/client";
import '@fontsource/oswald/400.css';
import '@fontsource/oswald/500.css';
import '@fontsource/oswald/700.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/jetbrains-mono/400.css';
import "@/index.css";
import App from "@/App";

// BUG-F14 fix: silence console.log/debug/info in production builds so that
// 94+ scattered `console.log` calls don't leak data (mappings, IDs, response
// payloads, stack traces with auth headers) on customer browsers. Errors
// and warnings remain visible because they are needed for runtime debugging.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
}

// 🩹 ResizeObserver loop suppression (P0 — Radix Select dispara este warning benigno en Safari iOS)
// El error "ResizeObserver loop completed with undelivered notifications" NO indica un bug real,
// es una limitación del spec. CRA dev-overlay lo muestra como Uncaught runtime error y asusta al usuario.
//
// Necesitamos interceptar ANTES del overlay de webpack-dev-server, por eso usamos capture=true.
const RO_PATTERNS = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];
const isResizeObserverError = (msg) =>
  typeof msg === 'string' && RO_PATTERNS.some((p) => msg.includes(p));

// 1) window.onerror handler
const _origOnError = window.onerror;
window.onerror = (message, ...args) => {
  if (isResizeObserverError(message)) return true;
  return _origOnError ? _origOnError(message, ...args) : false;
};

// 2) error event en capture phase (corre ANTES del overlay de CRA)
window.addEventListener('error', (event) => {
  if (isResizeObserverError(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

// 3) unhandledrejection (algunos browsers lo emiten por aquí)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  const msg = typeof reason === 'string' ? reason : reason?.message;
  if (isResizeObserverError(msg)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

// 4) Wrap nativo del ResizeObserver para tragar el loop silenciosamente
//    (defensa en profundidad — algunos overlays leen el callback antes de propagar)
if (typeof window.ResizeObserver !== 'undefined') {
  const _RO = window.ResizeObserver;
  window.ResizeObserver = class extends _RO {
    constructor(cb) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try { cb(entries, observer); } catch (e) {
            if (!isResizeObserverError(e?.message)) throw e;
          }
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        console.log('[SW] Registered:', reg.scope);
        // Check for updates periodically
        setInterval(() => reg.update(), 60 * 60 * 1000); // every hour
      })
      .catch((err) => console.log('[SW] Registration failed:', err));
  });
}
